import { render, staticRenderFns } from "./Navbartacticboard.vue?vue&type=template&id=8ab0a040&"
import script from "./Navbartacticboard.vue?vue&type=script&lang=js&"
export * from "./Navbartacticboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports